module.exports = __webpack_public_path__ + "img/symbol_11.4383896d.png";